import { ReactNode } from 'react';
import { Box, Stack } from '@mui/material';
import MainHeader from './MainHeader';
import { Styles, SxProp, mergeSx } from '@t2c/shared-fe';

// ----------------------------------------------------------------------

type Props = {
  children: ReactNode;
  wrapperSx?: SxProp;
};

export default function DashboardLayout({ children, wrapperSx }: Props) {
  return (
    <Stack sx={style.container}>
      <MainHeader />
      <Box sx={mergeSx(style.childWrapper, wrapperSx)}>{children}</Box>
    </Stack>
  );
}

const style: Styles = {
  container: {
    minHeight: '100vh',
  },
  childWrapper: {
    mt: { xs: 13, md: 8 },
    flexGrow: 1,
  },
};
